import React from "react";
import { Drawer, List, ListItem, ListItemButton, ListItemText, Toolbar, Divider, Typography, Box } from "@mui/material";
import DashboardIcon from "@mui/icons-material/Dashboard";
import EventNoteIcon from "@mui/icons-material/EventNote";
import DescriptionIcon from "@mui/icons-material/Description";
import MessageIcon from "@mui/icons-material/Message";
import SettingsIcon from "@mui/icons-material/Settings";
import LogoutIcon from "@mui/icons-material/Logout";
 
const drawerWidth = 260;
 
const menuItems = [
    { text: "Dashboard", icon: <DashboardIcon />, id: "dashboard", disabled: true },
    { text: "Document Intelligence", icon: <DescriptionIcon />, id: "document_intelligence" },
    { text: "Knowledge Base", icon: <EventNoteIcon />, id: "knowledge_base", disabled: true },
    { text: "Analytics", icon: <MessageIcon />, id: "analytics", disabled: true },
];
 
const SideBar = ({ selectedPage, handleNavigation }) => {
    return (
        <Box
            sx={{
                display:"flex",
                flexDirection:"column",
                width: "100%",
                height: "100%",
                backgroundColor: "#282c34",
                paddingTop: "20px", // Small padding from top
            }}
        >
            <Divider />
 
            {/* 🔹 Centered Navigation Items */}
            <Box sx={{ flexGrow: 1, display: "flex", flexDirection: "column", gap: 3, alignItems: "center", justifyContent: "center" }}>
                <List sx={{ width: "100%" }}>
                    {menuItems.map((item) => (
                        <ListItem key={item.id} disablePadding>
                            <ListItemButton
                                onClick={() => handleNavigation(item.id)}
                                sx={{
                                    backgroundColor: selectedPage === item.id ? "#EE3CFF" : "transparent",
                                    color: selectedPage === item.id ? "white" : "#94A3B8",
                                    "&:hover": { backgroundColor: "#EE3CFF", color: "white" },
                                    borderRadius: "8px",
                                    marginY: 1,
                                    width: "80%",
                                    display: "flex",
                                    justifyContent: "center",
                                }}
                                disabled={item.disabled}
                            >
                                <Box sx={{ color: selectedPage === item.id ? "white" : "#94A3B8", display: "flex", alignItems: "center", gap: 1 }}>
                                    {item.icon}
                                    <ListItemText primary={item.text} sx={{ textAlign: "center" }} />
                                </Box>
                            </ListItemButton>
                        </ListItem>
                    ))}
                </List>
            </Box>
 
            <Divider />
        </Box>
    );
};
 
export default SideBar;

